export default {
	tongguowomendewangzhan: '通过我们的网站',
	rangninyongyoubuyiyangdetiyan: '让您拥有不一样的出行体验。',
	huanyingguanglin: '欢迎光临~我们的目标是让您的旅行梦想成为现实。平台旨在为您提供价格合理的航班、酒店旅行方案，实现您完美的出行计划。',
	womenjianxin: '我们坚信通过我们的网站可以让每个人的出行经历记忆犹新，并留下美好的回忆，同时我们还在致力于保障您的每次交易的安全可靠，解决您的后顾之忧。',
	wulunzhoumo: '无论周末休闲游还是长途旅行，我们都将帮您为您提供完美的出行计划和方案。让我们一起开始体验吧！',
	weishenmexuanze: '为什么选择我们',
	duozhongluxingxuanze: '多种旅行选择',
	duozhongluxingxuanzemiaoshu: '我们提供多种旅行服务，以满足不同的需求偏好和预算。从价格优惠的经济舱到尊享服务的头等舱供客户进行选择，满足每一位客户的出行需求。',
	yonghuyouhaodeyudingliucheng: '用户友好的预订流程',
	yonghuyouhaodeyudingliuchengmiaoshu: '我们的预订流程简单便捷。只需简单操作即可筛选出满足用户需求的行程和产品并完成预定。',
	gexinghuatuijian: '个性化推荐',
	gexinghuatuijianmiaoshu: '我们根据客户的旅行偏好和预定历史，精准为客户提供量身定制的产品以满足客户需求。',
	kekaodekehufuwu: '可靠的客户服务',
	kekaodekehufuwumiaoshu: '我们提供了可靠的客户服务，以便于及时、快速的解决客户在购买产品前和购买后的所遇到的问题。',
	fengfudechanpindiliandejiage: '丰富的产品和低廉的价格',
	fengfudechanpindiliandejiagemiaoshu: '我们的网站汇集全球的产品资源，并提供了丰富的物美价廉的产品，并提供一系列定制化服务以满足您的旅行喜好。',
	anquankekaodejiaoyi: '安全可靠的交易',
	anquankekaodejiaoyimiaoshu: '我们使用最新技术确保交易的安全可靠。我们致力于保护客户的个人隐私信息，避免客户的任何个人信息泄露。'
};
